<template>
  <div class="table-options-config">
    <div class="setting-item">
      <el-collapse v-model="activeNames">
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="筛选项设置" name="1">
          <div class="verticallyCenter">
            <el-checkbox v-model="openTableFilter">开启筛选项</el-checkbox>
            <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick('filter')"></i>
          </div>
        </el-collapse-item>
        <el-collapse-item v-if="openTableFilter" class="dataContent" @mousedown.native="collapseMouseDown($event, '2')"
          title="字段匹配" name="2">
          <!-- <template slot="title">
            字段匹配
            <el-tooltip
              class="item"
              effect="dark"
              content="筛选项仅支持配置的字段类型为：下拉框、下拉复选"
              placement="top"
              :open-delay="1000"
              ><i class="tips-btn icon-portal-info2"></i>
            </el-tooltip>
          </template> -->
          <div class="verticallyCenter">
            <span class="mr12 width64">筛选项1</span>
            <el-select style="width: 152px" v-model="filedMappingValue" placeholder="请选择">
              <el-option v-for="(item1, index1) in filedMappingList" :key="index1" :label="item1.label"
                :value="item1.value">
              </el-option>
            </el-select>
          </div>
        </el-collapse-item>
        <el-collapse-item class="dataContent" @mousedown.native="collapseMouseDown($event, '3')" title="动画" name="3">
          <div class="setting-item clearFloat"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
            <div class="content">
              <div class="content-item verticallyCenter mb16">
                <el-checkbox v-model="scrollAutoSelf">开启滚动</el-checkbox>
              </div>
              <div v-if="scrollAutoSelf" class="radio-button-box mb16">
                <el-radio-group v-model="turnOnScroll1">
                  <el-radio-button label="self">手动滚动</el-radio-button>
                  <el-radio-button label="auto">自动滚动</el-radio-button>
                </el-radio-group>
              </div>
              <div v-if="turnOnScroll1 === 'auto'" class="content-item verticallyCenter mb16">
                <el-checkbox v-model="hoverStopScroll">悬浮停止滚动</el-checkbox>
              </div>
              <div v-if="turnOnScroll1 === 'auto'" class="content-item">
                <p class="font14 mb8">动画间隔时间</p>
                <slider-and-input inputWidth="large" inputHeight="small" :value.sync="waitTime" title=""
                  :themeKey="request_prefix" titlePosition="singleLine" :sliderMax="sliderMaxTime" suffix="秒" />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item v-if="showRowsType === 'customize'" class="dataContent" @mousedown.native="collapseMouseDown($event, '4')"
          title="分页设置" name="4">
          <div class="content">
            <div class="content-item verticallyCenter">
              <el-checkbox v-model="openPagination">开启分页</el-checkbox>
            </div>
            <div v-if="openPagination" class="mt12">
              <div class="verticallyCenter">
                <span class="fs14 mr12">页码数量</span>
                <div class="verticallyCenter el-input row-set">
                  <input class="el-input__inner" type="number" :min="1" :max="10" v-model="maxPageBtnNum" />
                  <div class="btn-wrapper">
                    <span :class="maxPageBtnNum === 1 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                      @click="changePagination(0)"></span>
                    <span :class="maxPageBtnNum === 20 ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                      @click="changePagination(1)"></span>
                  </div>
                </div>
              </div>
              <div class="verticallyCenter mt12">
                <span class="fs14 mr12" style="width: 52px;">位置</span>
                <el-radio-group v-model="pagePosition">
                  <el-radio value="left" label="left">左</el-radio>
                  <el-radio value="center" label="center">中</el-radio>
                  <el-radio value="right" label="right">右</el-radio>
                </el-radio-group>
              </div>
              <div class="verticallyCenter mt12">
                <slider-and-input
                  :value.sync="positionSize"
                  title="页码字号"
                  :sliderMin="0"
                  :sliderMax="100"
                  suffix="px"
                  inputWidth="small"
                />
              </div>
              <div class="verticallyCenter mt12">
                <span class="mr12">默认颜色</span>
                <cx-color-picker
                  class="flex1 lableWidth"
                  :isThemeColor.sync="positionIsThemeColor"
                  :colorArr.sync="positionColor"
                  >
                </cx-color-picker>
              </div>
              <div class="verticallyCenter mt12">
                <span class="mr12">选中颜色</span>
                <cx-color-picker
                  class="flex1 lableWidth"
                  :isThemeColor.sync="positionActiveIsThemeColor"
                  :colorArr.sync="positionActiveColor"
                  >
                </cx-color-picker>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item v-if="!!options.appId" class="dataContent" @mousedown.native="collapseMouseDown($event, '5')"
                          title="高级设置" name="5">
          <div class="content">
            <data-push :options="options"></data-push>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableSourceData from "./tableSourceData"
import { home_datePicker_children, bigScreen_datePicker_children } from "materials/datePicker/menus/index.js"
import { findCurrentComponentPathInLayoutByRectId, smartMathMax } from "utils"
import dataPush from "components/toolbar-option-components/utilsComponents/dataPush/dataPush.vue"
export default {
  name: "table-options-config",
  components: { tableSourceData, dataPush },
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2", "3", "4"],
      collapseActiveNames: ["3"],
      interval: 3,
      activeIndex: 0,
      editingFlag: false,
      oprateShow: false,
      fetchEnd: false,
      sliderMaxTime: 100,
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      dateIds: undefined,
    }
  },
  comments: {},
  created() {},
  mounted() {

  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeGridId() {
      return this.$store.state.states.activeGridId
    },
    pageLayoutList() {
      return this.$store.state[this.request_prefix].page.pageLayoutList || []
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
      }
    },
    openTableFilter: {
      get() {
        return this.options && this.options.hasOwnProperty("openTableFilter") ? this.options.openTableFilter : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openTableFilter", false, null)
        this.addDatePicker(newVal)
      }
    },
    filedMappingList: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filedMappingList", "filedMappingList", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMappingList", false, null)
      }
    },
    filedMappingValue: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filedMappingValue", "filedMappingValue", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMappingValue", false, null)
        this.addDatePicker(this.openTableFilter)
      }
    },
    turnOnScroll1: {
      get() {
        return this.options.turnOnScroll ? "auto" : "self"
      },
      set(newVal) {
        if(newVal == "auto"){
          this.$changeOptionsEV(true, "turnOnScroll", false)
        }else{
          this.$changeOptionsEV(false, "turnOnScroll", false)
        }
      }
    },
    hoverStopScroll: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverStopScroll", "hoverStopScroll", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverStopScroll", false)
      }
    },
    waitTime: {
      get() {
        return this.options.waitTime
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "waitTime", false)
      }
    },
    scrollAutoSelf:{
      get() {
        return this.options.scrollAutoSelf || false
      },
      set(newVal) {
        if(!newVal){
          this.$changeOptionsEV([newVal, false], ["scrollAutoSelf", "turnOnScroll"], false)
        } else {
          this.$changeOptionsEV(newVal, "scrollAutoSelf", false)
        }
      }
    },
    showRowsType: {
      get() {
        return this.options.showRowsType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showRowsType", false)
      }
    },
    showRows: {
      get() {
        return this.options.showRows
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showRows", false)
      }
    },
    openPagination: {
      get() {
        return this.options.hasOwnProperty("openPagination") ? this.options.openPagination : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openPagination", false)
      }
    },
    maxPageBtnNum: {
      get() {
        return this.options.hasOwnProperty("maxPageBtnNum") ? this.options.maxPageBtnNum : 7
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "maxPageBtnNum", false)
      }
    },
    pagePosition: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pagePosition", "pagePosition", "center")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pagePosition", false)
      }
    },
    positionSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "positionSize", "positionSize", 14)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "positionSize", false)
      }
    },
    positionIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "positionIsThemeColor", "positionIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "positionIsThemeColor", false)
      }
    },
    positionColor: {
      get() {
        const color = this.request_prefix === "bigScreen" ? "rgba(255,255,255,1)" : "rgba(0,0,0,1)"
        return this.checkAndSetPrimaryVal(this.options, "positionColor", "positionColor", color)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "positionColor", false)
      }
    },
    positionActiveIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "positionActiveIsThemeColor", "positionActiveIsThemeColor", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "positionActiveIsThemeColor", false)
      }
    },
    positionActiveColor: {
      get() {
        return this.options.hasOwnProperty("positionActiveColor") ? this.options.positionActiveColor : "rgba(255,255,255)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "positionActiveColor", false)
      }
    },
    isLayout() {
      if (this.$store.state[this.request_prefix]?.page?.isPhoneFullScreen) {
        // 翻页模版不能设置为布局模式
        return false
      }
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "filter":
          this.explainTitle = "开启筛选项"
          this.explainTips = "详细使用方法见下图"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/table-filer.png")
          break
        default:
      }
    },
    changePagination(flag) {
      if (flag === 1) {
        if (this.maxPageBtnNum < 20) {
          this.maxPageBtnNum++
        }
      } else {
        if (this.maxPageBtnNum > 1) {
          this.maxPageBtnNum--
        }
      }
    },
    getParentNodeByClassName(e, res = [], parentClass) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        // if(elClasslist.length === 0){
        //   return res
        // }
        if (elClasslist && [].find.call(elClasslist, it => it === parentClass)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNodeByClassName(parentNode, res, parentClass)
        }
      } else {
        return res
      }
    },
    getDateRectId() {
      const stage = this.$store.state[this.request_prefix]
      let dateIds = undefined
      let pageLayout = []
      if (this.isLayout) {
        let layoutIndex = findCurrentComponentPathInLayoutByRectId(this.pageLayoutList, this.ids.rect_id).join("_")
        pageLayout = this.getAttrById(stage, { pageLayoutId: layoutIndex }, "pageLayout")
      } else {
        pageLayout = this.getAttrById.call(this, stage, { container_id: this.ids.container_id }).children
      }
      let children = this.isLayout ? pageLayout.rectIds : pageLayout
      if (children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          let rectAttr = this.isLayout ? this.getAttrById(
            this.$store.state[this.request_prefix],
            {
              ...this.ids,
              rect_id: children[i]
            }
          ) : children[i]
          const gridItem = this.getParentNodeByClassName(document.querySelector(".vdr.active"), [] ,"grid-item-content")[0]
          let dataId = null
          let flag = false // 是否是同一个栅格
          if (gridItem) {
            dataId = gridItem.getAttribute("data-i")
            flag = rectAttr.i === dataId
          } else {
            flag = true
          }
          rectAttr = rectAttr.options ? rectAttr.options : rectAttr
          if (flag && rectAttr.pluginName?.includes("dateFilterTablePlugin")) {
            dateIds = this.isLayout ? children[i] : children[i].rect_id
            break
          }
        }
      }
      return dateIds
    },
    addDatePicker(flag) {
      const stage = this.$store.state[this.request_prefix]
      let layoutIndex = findCurrentComponentPathInLayoutByRectId(this.pageLayoutList, this.ids.rect_id).join("_")
      let pageLayout = this.getAttrById(stage, { pageLayoutId: layoutIndex }, "pageLayout")
      let dateIds = this.getDateRectId()
      if (flag) {
        let filedMappingLable = this.filedMappingList.find(item => item.value === this.filedMappingValue)?.label
        const isTime = filedMappingLable?.includes("时间") || filedMappingLable?.includes("日期")
        if (dateIds) {
          let isShow = isTime ? true : false
          // 如果为true,将日期组件的层级高于表格组件
          let tableZIndex = this.options.zIndex
          this.$changeOptionsEV([isShow,tableZIndex+1], ["isShow","zIndex"], false, null, {
            ...this.ids,
            rect_id: dateIds
          })
          return
        }
        if (!isTime) return
        const datePicker = this.request_prefix === "bigScreen" ? bigScreen_datePicker_children[1] : home_datePicker_children[1]
        let options = JSON.parse(JSON.stringify(datePicker.attribute.options))
        if (this.isLayout) {
          options.left = 0
          options.top = 0
        } else {
          options.left = this.options.left
          options.top = this.options.top
        }
        options.width = 320
        options.zIndex = this.options.zIndex + 1
        options.pluginName = ["dateFilterTablePlugin"]
        options.relativeComponentId = this.ids // 关联表格的id
        options.dateType = "datetimerange"
        options.dateFormat = "yyyy-MM-dd HH:mm:ss"
        options.dataPickerType = 3
        isTime ? options.isShow = true : options.isShow = false
        let tmpData = JSON.parse(JSON.stringify(this.getAttrById(stage, this.ids, "rect")))
        tmpData.options = options
        tmpData.shape = "cxDatePicker"
        tmpData.active = false
        this.$store.commit(this.request_prefix + "/ELEMENT_ADD", {
          containerID: this.ids.container_id,
          data: JSON.parse(JSON.stringify(tmpData))
        })
        if (this.isLayout) {
          const allRects = this.getAttrById.call(this, stage, { container_id: this.ids.container_id }).children
          let _rect_id = -1
          if (allRects.length > 0) {
            _rect_id = smartMathMax(
              ...allRects.map(function (o) {
                return o.rect_id
              })
            )
          }
          pageLayout.rectIds.push(_rect_id)
          let param = {
            ...this.ids,
            option_name: "rectIds",
            option_val: pageLayout.rectIds
          }
          this.$store.dispatch(this.request_prefix + "/changeOptions", param)
        }
      } else if (dateIds) {
        this.$changeOptionsEV(false, "isShow", false, null, {
          ...this.ids,
          rect_id: dateIds
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.width64 {
  width: 64px;
}
.radio-button-box ::v-deep .el-radio-button{
  padding: 2px;
  background-color: var(--inputBackGround);
}
.radio-button-box ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  background-color: var(--leftMenuBgColor);
  color: var(--themeColor);
  }
.bigScreen .radio-button-box ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  background-color: #575C66;
  color: #ffffff;
}
.radio-button-box ::v-deep .el-radio-button__inner{
  padding: 5px 20px;
  border: 0;
  background-color: var(--inputBackGround);
  border-color:  var(--inputBackGround);
  color: var(--thirdTextColor);
  box-shadow: none;
  border-radius: 6px;
}
.row-set {
  flex: 1;
  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 12px;
    width: 72px;
  }
  .btn-wrapper {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    flex: 1;
    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }
      &:not(.disabled):hover {
        color: var(--themeColor);
      }
      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
.lableWidth{
  width: calc(100% - 70px);
}
</style>
